export default {
  id: 143,
  title: 'Target #143 - Simply Circle',
  url: 'https://cssbattle.dev/play/143',
  colors: ['#F5D6B4', '#D86F45'],
  solution:
    '<p><style>body{background:#f5d6b4;margin:0}p{width:200;height:200;background:#d86f45;border-radius:50%}</style>',
}
